/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_link_google = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Google`)
};

const zh_hans1_settings_link_google = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绑定 Google`)
};

const zh_hant1_settings_link_google = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`綁定 Google`)
};

const fr_settings_link_google = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lier Google`)
};

const de_settings_link_google = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google verknüpfen`)
};

const ja_settings_link_google = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google を連携`)
};

const ko_settings_link_google = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google 연결`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_link_google = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_link_google(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_link_google", locale)
	if (locale === "en") return en_settings_link_google(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_link_google(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_link_google(inputs)
	if (locale === "fr") return fr_settings_link_google(inputs)
	if (locale === "de") return de_settings_link_google(inputs)
	if (locale === "ja") return ja_settings_link_google(inputs)
	return ko_settings_link_google(inputs)
};